class LeaderboardItem {
  agencyName = '';

  currentYearPoints = 0;

  currentYearPointsWithOffset = 0;

  previousYearPoints = 0;

  previousYearPointsWithOffset = 0;

  currentYear = 0;

  previousYear = 0;

  currentYearIndex = 0;

  previousYearIndex = 0;

  currentYearOffset = 0;

  previousYearOffset = 0;

  constructor(data) {
    this.agencyName = data.agencyName;

    this.currentYearPoints = data.currentYearPoints;
    this.previousYearPoints = data.previousYearPoints;

    this.currentYearPointsWithOffset = data.currentYearPointsWithOffset;
    this.previousYearPointsWithOffset = data.previousYearPointsWithOffset;

    this.currentYearIndex = data.currentYearIndex;
    this.previousYearIndex = data.previousYearIndex;

    this.currentYear = data.currentYearLabel;
    this.previousYear = data.previousYearLabel;

    this.currentYearOffset = data.currentYearOffset;
    this.previousYearOffset = data.previousYearOffset;
  }

  getMaxPoints(maxPoints) {
    if (this.currentYearPointsWithOffset > maxPoints) {
      return this.currentYearPointsWithOffset;
    }

    return maxPoints;
  }

  getRelativePoint(maxScore) {
    const ratio = (this.currentYearPointsWithOffset || 0) / maxScore;
    return ratio * 100;
  }

  /**
   *
   * @param data{ {agencyName: string, currentYearPoints: number, yearPoints: {} } }
   * @returns {LeaderboardItem}
   */
  static fromObject(data) {
    return new LeaderboardItem(data);
  }

  /**
   *
   * @param list{[{agencyName: string, currentYearPoints: number, yearPoints: {} }]}
   * @returns {LeaderboardItem[]}
   */
  static fromList(list = []) {
    return (list || []).map(LeaderboardItem.fromObject);
  }
}

export default LeaderboardItem;
